module.exports = __webpack_public_path__ + "media/images/document-8cf18d13.svg";